module.exports = __webpack_public_path__ + "media/images/application/default/default-economie-25f05a708df19fecb3628b905c8f1bbf.jpg";